import * as React from 'react';
import {connect} from 'react-redux';

import {
  SaleServiceBlock,
} from '../../components/service_block/sale_service_block';
import {IPromo} from '../../models/promo';
import {IMainPage} from '../../models/mainpage';
import {IRegionsData} from '../../models/regions_data';
import {trackService} from '../../helpers/metrics_helper';

interface IProps {
  promo: IPromo[];
  regionsData: IRegionsData;
  section: string;
}

export class SaleServicesComponent extends React.Component<IProps> {
  public render() {
    return (
      <SaleServiceBlock
        coordinates={this.props.regionsData.subdomainRegionCoordinates}
        section={this.props.section}
        onAdsClick={(eventLabel: string) => trackService(eventLabel)}
      />
    );
  }
}

export const SaleServices = connect<IProps, {}, {}>((state: {
  mainpage: IMainPage,
}) => ({
  promo: state.mainpage.promoBlocks,
  regionsData: state.mainpage.regionsData,
  section: state.mainpage.section,
}))(SaleServicesComponent);
